
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1b1a8b46!sass-loader?data=@import \"~assets/styles/base\";@import \"~assets/styles/variables\";@import \"~assets/styles/mixins\";&sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Songs.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Songs.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1b1a8b46!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Songs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Songs.vue
// module id = 307
// module chunks = 2